import React from "react";
import { Box } from "@chakra-ui/react";

const Layout = props => {
	return (
		<Box display="flex" flexDir="column" h={"100%"} w="100%">
			{props.children}
		</Box>
	);
};

export default Layout;
